import _ from 'lodash'
import { CancelTokenSource } from 'axios'
import { IMemberConferenceParams } from './MemberConference.interface'
import { IPagination } from 'types/entities'
import axios from 'services/axios'
import { ENDPOINTS } from 'const/endpoints'
import { commonMessages } from 'utils/messages'
import { onCreateEndpointsWithClientid } from 'utils/common'
import { IMemberConference, IMemberConferenceDropdownParams } from './MemberConference.hooks'

export function getMemberConference(
	id: string | undefined,
	params?: Partial<IMemberConferenceParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<Partial<any>>>(
		onCreateEndpointsWithClientid(ENDPOINTS.MEMBER_CONFERENCE) + '/' + id,
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

export function getMemberConferenceDropdown(
	id: string,
	params: Partial<IMemberConferenceDropdownParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<IMemberConference>>(
		onCreateEndpointsWithClientid(ENDPOINTS.MEMBER_DROPDOWN_CONFERENCE) + '/' + id,
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}
